export const showDesmosCalculator = (grade: number, element: HTMLElement) => {
  const desmos = (window as any).Desmos
  if (!desmos || !element) return null

  const numericGrade = Number(grade)

  /**
   * Grades 2 through 7 and kindergarten grade 9 use the four-function Desmos
   * calculator. Grade 8 uses scientific; graphing is selected separately.
   */
  switch (numericGrade) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
      return desmos.FourFunctionCalculator(element, {
        additionalFunctions: ['sqrt', 'percent']
      })
    case 8:
      return desmos.ScientificCalculator(element)
    case 9:
      return desmos.FourFunctionCalculator(element, {
        additionalFunctions: ['sqrt', 'percent']
      })
    default:
      return desmos.ScientificCalculator(element)
  }
}
